export default "__VITE_ASSET__DibniDXe__"